import type { InvoiceEmailBadgeState } from '../derive-invoice-email-badge';

export function getInvoiceEmailAriaLabel(
  invoiceNumber: string | null | undefined,
  badgeState: InvoiceEmailBadgeState
): string {
  const base = invoiceNumber ? `Invoice ${invoiceNumber} email actions` : 'Invoice email actions';
  switch (badgeState) {
    case 'warning':
      return `${base}. No billing contact on parent agreement`;
    case 'success':
      return `${base}. Last email accepted`;
    case 'pending':
      return `${base}. Last email pending delivery`;
    case 'scheduled':
      return `${base}. Email scheduled for future delivery`;
    case 'failure':
      return `${base}. Last email failed`;
    default:
      return base;
  }
}
